import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useOptionalOrganization } from "@/contexts/organization-context";
import {
  type GroupedProjectsResult,
  HomeProjectsPanel,
  useHomeSelectedGroup,
} from "@/features/home";
import { useGroupedProjects } from "@/features/project/hooks";

function HomePage() {
  const organization = useOptionalOrganization();
  const organizationId = organization?.organizationId ?? null;
  const navigate = useNavigate();
  const selectedGroupId = useHomeSelectedGroup(organizationId ? String(organizationId) : null);
  const groupedProjects = useGroupedProjects(organizationId) as GroupedProjectsResult | undefined;

  return (
    <main className="flex flex-1 flex-col overflow-hidden">
      <div className="flex-1 overflow-y-auto p-8 px-10">
        <HomeProjectsPanel
          organizationId={organizationId}
          groupedProjects={groupedProjects}
          selectedGroupId={selectedGroupId}
          onOpenProject={(project) =>
            navigate({
              to: "/project/$projectId",
              params: { projectId: project.slug },
            })
          }
          onOpenCreatedProject={(slug) =>
            navigate({
              to: "/project/$projectId",
              params: { projectId: slug },
            })
          }
        />
      </div>
    </main>
  );
}

export const Route = createFileRoute("/")({
  component: HomePage,
});
